/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function IntegrationDeliveryStatisticsController($mdDialog, integrationService, entityId) {
    var vm = this;
    vm.rows = [];
    vm.loading = true;
    vm.cancel = cancel;

    integrationService.getDeliveryStatistics(entityId).then(
        (data) => {
            vm.rows = data;
            vm.loading = false;
        },
        () => {
            vm.loading = false;
        }
    );

    function cancel() {
        $mdDialog.cancel();
    }
}



// WEBPACK FOOTER //
// ./src/app/integration/integration-delivery-statistics.controller.js